import { articles, type Article } from "@/data/articles";
import { jsonPosts } from "./registry";

export const blogArticles: Article[] = [
  ...jsonPosts.map((post): Article => ({
    slug: post.slug, frPath: post.frPath, enPath: post.enPath, image: post.cover.src,
    fr: { ...post.fr.card, category: post.fr.category, date: post.fr.date, readingTime: post.fr.readingTime },
    en: { ...post.en.card, category: post.en.category, date: post.en.date, readingTime: post.en.readingTime },
  })),
  ...articles,
];
